import { NoWrap } from 'atoms';

const switcher = ({ component }) => component || NoWrap;

export default switcher;
